//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Predicting_Height_From_KH",
  data() {
    return {
      form: {
        age: "",
        knee_heel_spacing: "",
      },
      hasScore: false,
      disabled: false,
      num: "",
      num1: "",
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        self.hasScore = true;
        self.num = (
          84.88 -
          0.24 * form.age +
          1.83 * form.knee_heel_spacing
        ).toFixed(2);
        self.num1 = (
          64.19 -
          0.04 * form.age +
          2.02 * form.knee_heel_spacing
        ).toFixed(2);
        return String(self.num, self.num1);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Predicting_Height_From_KH.vue